export default "__VITE_ASSET__6263e11d__"